import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";

export default function AdminAuditLog() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/admin/audit", { params: { limit: 200 } })
      .then((r) => setRows(r.data.audit_log))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-4 max-w-4xl" data-testid="admin-audit-log">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Audit log</h1>
        <p className="text-sm text-slate-500 mt-1">Every admin action, append-only.</p>
      </div>

      <Card>
        <CardContent className="p-0">
          {loading && <p className="p-6 text-sm text-slate-400">Loading…</p>}
          {!loading && rows.length === 0 && (
            <p className="p-6 text-sm text-slate-400 italic">No audit events yet.</p>
          )}
          {!loading &&
            rows.map((a) => (
              <div key={a.id} className="border-b last:border-0 p-4" data-testid={`audit-row-${a.id}`}>
                <div className="flex justify-between text-xs text-slate-500">
                  <span>{new Date(a.timestamp).toLocaleString("en-IN")}</span>
                  <span className="font-medium">{a.admin_email}</span>
                </div>
                <p className="text-sm mt-1 text-slate-800">
                  <span className="font-semibold">{a.action.replaceAll("_", " ")}</span>
                  {" · "}
                  <span className="text-slate-500">
                    {a.target_type}:{a.target_id?.slice(0, 8)}
                  </span>
                </p>
                {(a.old_value !== null || a.new_value !== null) && (
                  <p className="text-xs text-slate-600 mt-1">
                    {typeof a.old_value === "object"
                      ? JSON.stringify(a.old_value).slice(0, 100)
                      : String(a.old_value)}{" "}
                    →{" "}
                    {typeof a.new_value === "object"
                      ? JSON.stringify(a.new_value).slice(0, 100)
                      : String(a.new_value)}
                  </p>
                )}
                {a.reason && <p className="text-xs text-slate-600 italic mt-1">{`"${a.reason}"`}</p>}
              </div>
            ))}
        </CardContent>
      </Card>
    </div>
  );
}
